import React from 'react';
import Icon from '../../atoms/Icon';
import './OrderSearch.css';

interface OrderSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const OrderSearch: React.FC<OrderSearchProps> = ({ 
  value, 
  onChange, 
  placeholder = "Search orders...",
  className = '' 
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const clearSearch = () => {
    onChange('');
  };

  return (
    <div className={`order-search ${className}`}>
      <div className="search-input-container">
        <Icon type="search" size="small" className="search-icon" />
        <input
          type="text"
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          className="search-input"
        />
        {value && (
          <button
            className="clear-button"
            onClick={clearSearch}
            title="Clear search"
          >
            <Icon type="error" size="small" />
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderSearch;
